import { CancelablePromise, OpenAPI } from "@/api";
import { HomeResponse } from "@/api/models/system/HomeResponse";
import { request as __request } from "@/api/core/request";

export class SystemService {
  public static Home(): CancelablePromise<HomeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/system/home",
    });
  }
}
